import { useTranslation } from 'react-i18next';
import { Loading } from '../../loading';
import { useGetCurrentMember } from '../members/members.queries';
import { AdminDashboard } from './admin-dashboard';
import { UserDashboard } from './user-dashboard';

/**
 * Dashboard wrapper that waits for member permissions to load
 * before rendering the appropriate dashboard based on user role.
 * Uses role priority: ADMIN > USER (mutually exclusive).
 */
export function Dashboard() {
  const { t } = useTranslation('dashboard');
  const { data: member, isLoading: isMemberLoading, error: memberError } = useGetCurrentMember();

  if (isMemberLoading) {
    return <Loading stage="permissions" />;
  }

  if (memberError) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-destructive mb-2">{t('permissions.errorTitle')}</h2>
          <p className="text-muted-foreground">{t('permissions.errorDescription')}</p>
        </div>
      </div>
    );
  }

  // Role priority: ADMIN takes precedence over USER
  // This ensures only one dashboard renders even if user has multiple roles
  const isAdmin = member?.roles?.includes('ADMIN');

  if (isAdmin) {
    return <AdminDashboard />;
  }

  return <UserDashboard />;
}
